// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const prinplup: PokeData = {
  "id": 394,
  "name": "prinplup",
  "height": 8,
  "weight": 230,
  "base_experience": 142,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "fury-attack",
    "tackle",
    "double-edge",
    "growl",
    "mist",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "peck",
    "drill-peck",
    "bide",
    "bubble",
    "charm",
    "swagger",
    "metal-claw",
    "whirlpool",
    "aerial-ace",
    "water-sport",
    "water-pulse",
    "roost",
    "brine",
    "liquidation"
  ],
  "moves": [
    "tackle",
    "growl",
    "hydro-pump",
    "bubble-beam",
    "peck",
    "bubble",
    "metal-claw",
    "whirlpool",
    "aerial-ace",
    "roost",
    "brine",
    "liquidation",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 205,
    "item": null,
    "species": [
      {
        "name": "piplup",
        "order": 423,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "prinplup",
        "order": 424,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 393,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "empoleon",
        "order": 425,
        "types": [
          PokeType.WATER,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 394,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68,
    "speed": 50,
    "ability_power": 81
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
